import script from "./FooterCom.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterCom.vue?vue&type=script&setup=true&lang=js"

import "./FooterCom.vue?vue&type=style&index=0&id=ec1537d0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec1537d0"]])

export default __exports__